import { useSsrAdapter as n } from "./ghl-ui.es791.js";
import { defineComponent as c, ref as a, h as d } from "vue";
import { cssrAnchorMetaName as i, c as t } from "./ghl-ui.es792.js";
const h = t(".v-x-scroll", {
  overflow: "auto",
  scrollbarWidth: "none"
}, [
  t("&::-webkit-scrollbar", {
    width: 0,
    height: 0
  })
]), m = c({
  name: "XScroll",
  props: {
    disabled: Boolean,
    onScroll: Function
  },
  setup() {
    const o = a(null);
    function l(e) {
      !(e.currentTarget.offsetWidth < e.currentTarget.scrollWidth) || e.deltaY === 0 || (e.currentTarget.scrollLeft += e.deltaY + e.deltaX, e.preventDefault());
    }
    const s = n();
    return h.mount({
      id: "vueuc/x-scroll",
      head: !0,
      anchorMetaName: i,
      ssr: s
    }), Object.assign({
      selfRef: o,
      handleWheel: l
    }, {
      scrollTo(...e) {
        var r;
        (r = o.value) === null || r === void 0 || r.scrollTo(...e);
      }
    });
  },
  render() {
    return d("div", {
      ref: "selfRef",
      onScroll: this.onScroll,
      onWheel: this.disabled ? void 0 : this.handleWheel,
      class: "v-x-scroll"
    }, this.$slots);
  }
});
export {
  m as default
};
